module.exports = {"TXTWCL_Need_helpX":{"id":"TXTWCL_Need_helpX","defaultMessage":"Hai bisogno di aiuto?","flags":["TRACK"],"track":"Need help?"}}